import { ListKeys } from '@src/constants/microcredits';

import type { IMessage } from '../components/MessageBlock';

export const getErrorText = (): IMessage => ({
    title: 'Упс! Что-то пошло не так...',
    message: 'Произошла ошибка',
});

export const getEmptyProductsTexts = (listKey: ListKeys): IMessage => {
    if (listKey === ListKeys.ONLINE) {
        return {
            title: 'Ничего не найдено :(',
            message: 'По вашему запросу нет предложений. Попробуйте изменить параметры поиска. Попробуйте еще раз!',
        };
    }
    return {
        title: 'Ничего не найдено :(',
        message:
            'По вашему запросу нет предложений. Измените срок или сумму, чтобы найти для себя лучшие предложения. Нужно уменьшить срок или увеличить сумму. Попробуйте еще раз!',
    };
};
